import { useSelector } from 'react-redux'
import { selectMeta } from '@/redux/meta/selector'
import { useRetrieveCustomerInfoQuery } from '@/services/local'

const useAuth = () => {
  const meta = useSelector(selectMeta)

  return useRetrieveCustomerInfoQuery(meta.cartName as string, {
    skip: !meta.cartName,
  })
}

export default useAuth
